import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import StandaloneCompanyCreationForm from "@/components/auth/StandaloneCompanyCreationForm";
import { useCompanyCreation } from "@/hooks/useCompanyCreation";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const CompanyCreationPage = () => {
  const { user, profile, isLoading: authLoading } = useAuth();
  const navigate = useNavigate();
  
  const {
    companyName,
    setCompanyName,
    website,
    setWebsite,
    streetAddress,
    setStreetAddress,
    suburb,
    setSuburb,
    city,
    setCity,
    provinceState,
    setProvinceState,
    postalCode,
    setPostalCode,
    setLogoUrl,
    isLoading,
    handleSubmit,
  } = useCompanyCreation();

  useEffect(() => {
    document.title = "Create New Company | Doyence Estimating";
  }, []);

  // Redirect if user is not authenticated
  useEffect(() => {
    if (!authLoading && !user) {
      navigate("/login");
    }
  }, [user, authLoading, navigate]);

  if (authLoading) {
    return (
      <div className="min-h-screen bg-[#375062] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white mx-auto"></div>
          <p className="mt-2 text-white/70">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#375062] flex flex-col justify-center px-4 py-12">
      <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
        <div className="text-center mb-6">
          <div className="flex items-center justify-center gap-3 mb-2">
            <img src="/icon-mark.png" alt="Doyence" className="h-10 w-10" />
            <h1 className="text-3xl font-bold text-white">
              Doyence
            </h1>
          </div>
          <h2 className="text-xl font-semibold tracking-tight text-white">Create Your Company</h2>
          <p className="mt-2 text-white/70">
            Set up your company profile to get started
          </p>
        </div>

        <Card className="w-full">
          <CardHeader>
            <CardTitle className="text-2xl">Company Information</CardTitle>
            <CardDescription>Add your company details to create your business profile</CardDescription>
          </CardHeader>
          <CardContent>
            <StandaloneCompanyCreationForm
              companyName={companyName}
              setCompanyName={setCompanyName}
              website={website}
              setWebsite={setWebsite}
              streetAddress={streetAddress}
              setStreetAddress={setStreetAddress}
              suburb={suburb}
              setSuburb={setSuburb}
              city={city}
              setCity={setCity}
              provinceState={provinceState}
              setProvinceState={setProvinceState}
              postalCode={postalCode}
              setPostalCode={setPostalCode}
              setLogoUrl={setLogoUrl}
              isLoading={isLoading}
              onSubmit={handleSubmit}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CompanyCreationPage;